export default __webpack_public_path__ + "static/media/Jose-Antoni-Cao-300x300.45f1cc68.jpg";